import { render, staticRenderFns } from "./FiltrosTemplate.vue?vue&type=template&id=a4c7a704&scoped=true&"
import script from "./FiltrosTemplate.vue?vue&type=script&lang=js&"
export * from "./FiltrosTemplate.vue?vue&type=script&lang=js&"
import style0 from "./FiltrosTemplate.vue?vue&type=style&index=0&id=a4c7a704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c7a704",
  null
  
)

export default component.exports